import { ChangeEvent, KeyboardEvent, ReactNode } from 'react';

interface WelcomeFieldProps {
    heading: string;
    /** Optional "Current Welcome Message" block rendered before the description (Editor only). */
    currentValueNode?: ReactNode;
    value: string;
    onChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
    onKeyDown: (e: KeyboardEvent<HTMLTextAreaElement>) => void;
    disabled: boolean;
    textareaClassName: string;
    counterClassName: string;
}

export const WelcomeField = ({
    heading,
    currentValueNode,
    value,
    onChange,
    onKeyDown,
    disabled,
    textareaClassName,
    counterClassName
}: WelcomeFieldProps) => (
    <>
        <h4 className={`text-lg font-semibold ${disabled ? 'text-gray-500' : 'text-jtc-very-dark-grey'}`}>
            {heading}
        </h4>
        {currentValueNode}
        <p className={`text-sm mb-4 ${disabled ? 'text-gray-400' : 'text-gray-500'}`}>
            Set a greeting message that users will see when they first open the assistant. You can use the following placeholders:
        </p>
        <ul className={`text-sm mb-4 list-disc list-inside ${disabled ? 'text-gray-400' : 'text-gray-500'}`}>
            <li><code className="bg-gray-100 px-1 rounded">{'{{firstName}}'}</code> - the user's first name</li>
            <li><code className="bg-gray-100 px-1 rounded">{'{{assistantFiles}}'}</code> - a bullet list of files the assistant has access to</li>
        </ul>
        <textarea
            id="welcomeMessage"
            className={textareaClassName}
            placeholder={`Hi {{firstName}}! 👋 I have access to the following documents:\n{{assistantFiles}}\nFeel free to ask me anything about them!`}
            value={value}
            onChange={onChange}
            onKeyDown={onKeyDown}
        />
        <div className={counterClassName}>
            {value.length} / 1500
        </div>
    </>
);
